import { Type, Exclude, Transform, Expose } from 'class-transformer';
import { DocumentSnapshot, QuerySnapshot } from 'firebase/firestore';
import { _FirebaseDocument, forceArray } from './Models';
import { Ratings } from './Assessment';
import { FeedbacksBase } from './Feedback';

export class Topic extends FeedbacksBase {
    @Expose()
    public name: string
    @Expose()
    public justification: string
    @Expose()
    @Type(() => Ratings)
    public ratings: Ratings
    @Exclude()
    public questions: Question[]


    collection(): string {
        return "topics";
    }
    static fromFirebase(o: DocumentSnapshot, questions: QuerySnapshot | null): Topic | null {
        const topic = _FirebaseDocument._fromFirebase(Topic, o)
        if (topic && questions) {
            topic.questions = questions.docs
            .map(q => Question.fromFirebase(q))
            .filter(q => q !== null)
            .sort((a, b) => (parseInt(a.question_number, 10) || 0) - (parseInt(b.question_number, 10) || 0))
        }
        return topic
    }
}

export class Question extends FeedbacksBase {
    @Expose()
    public compliance_rating: string
    @Expose()
    public justification: string
    @Expose()
    public description?: string
    @Expose()
    public question_number: string
    @Expose()
    public question_text: string
    @Expose()
    @Transform(forceArray)
    @Type(() => Evidence)
    public evidences: Evidence[]

    collection(): string {
        return "questions";
    }
    static fromFirebase(o: DocumentSnapshot): Question | null {
        return _FirebaseDocument._fromFirebase(Question, o)
    }
}

export class Evidence {
    @Expose()
    public file: string
    @Expose()
    public section_number: string
    @Expose()
    public section_title: string
    @Expose()
    public quotation: string
    @Expose()
    public justification: string
    /** `projects/{p}/datasources/{d}/documents/{id}`, when the agent kept it: what opens the file (MYAC-1644). */
    @Expose()
    public document_path?: string
}